import jQuery from 'jquery';

// Ensure jQuery is available globally for legacy plugins that expect it
if (typeof window !== 'undefined') {
    window.jQuery = window.jQuery || jQuery;
    window.$ = window.$ || jQuery;
}

export default jQuery;
